import React from "react";
import { Route } from "react-router-dom";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";

const PrivateRoute = ({ component, ...rest }) => {
    const { isAuthenticated } = useAuth0();

    return (
        <Route
            exact
            {...rest}
            component={
                isAuthenticated
                    ? component
                    : withAuthenticationRequired(component)
            }
        />
    );
};

export default PrivateRoute;
